import StafetHeader from '../StafetHeader/StafetHeader.vue'
import StafetDonationStepOne from '../StafetDonationStepOne/StafetDonationStepOne.vue'
import StafetDonationStepTwo from '../StafetDonationStepTwo/StafetDonationStepTwo.vue'
import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import mapStafetHeaderSteps from 'foundation/js/stafet/mapStafetHeaderSteps'
import getCommonComputedFields from 'foundation/js/stafet/getCommonComputedFields'
import FormStepSubmitting from '../FormStepSubmitting/FormStepSubmitting.vue'
import stepsConfig from './config/stepsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import updateItemFromStorage from 'foundation/js/sessionStorageWrapper/updateItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import { scrollToFirstError } from '../../foundation/js/inputValidators/scrollToFirstError'
import updateBasket from './methods/updateBasket'

export default {
    name: 'StafetDonationFlow',
    components: {
        StafetHeader,
        StafetDonationStepOne,
        StafetDonationStepTwo,
        FormStepSubmitting
    },
    props: {
        stafetId: {
            type: String,
            required: true
        },
        loggedIn: {
            type: Boolean,
            required: false,
            default: false
        },
        holdList: {
            type: Array,
            required: false,
            default: []
        },
        userData: {
            type: Object,
            required: false,
            default: {}
        },
        holdId: {
            type: String,
            required: false,
            default: ''
        },
        deltagerId: {
            type: String,
            required: false,
            default: ''
        },
        minimumDonationAmount: {
            type: Number,
            required: false,
            default: 50
        },
        donationAmounts: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    setup(props) {
        const store = useStore()
        const displayInputError = ref(false)

        const labels = computed(() => {
            return store.state.labels.collections[
                'SFLSupportWithDonationLabels'
            ]
        })

        // For testing purposes, making sure isFormUnavailable is truthy
        const isFormUnavailable = ref(props.formUnavailable ? props.formUnavailable : true)

        const headerSteps = computed(() => {
            return mapStafetHeaderSteps(
                steps.value.slice(0, steps.value.length - 1),
                currentStep.value,
                labels.value
            )
        })

        const isSubmitting = computed(() => {
            return store.state.donation.isSubmitting
        })

        onMounted(() => {
            store.dispatch('donation/stafetId', { stafetId: props.stafetId })
            store.dispatch('donation/steps', {
                steps: stepsConfig
            })

            store.dispatch('donation/donationFor', {
                donationFor:
                    props.deltagerId !== ''
                        ? 'participant'
                        : props.holdId
                          ? 'team'
                          : 'none'
            })

            store.dispatch('donation/donationTeam', {
                team: props.holdId
            })
            store.dispatch('donation/donationParticipant', {
                participant: props.deltagerId
            })
        })

        const { userInputs, steps, currentStep, currentStepName } =
            getCommonComputedFields(store.state.donation)

        const handleStepCompleted = () => {
            steps.value.find(
                (item) => item.step === currentStep.value
            ).completed = true

            store.dispatch('donation/steps', {
                steps: steps.value
            })

            const unCompletedSteps = steps.value.filter(
                (item) => !item.completed
            )

            if (unCompletedSteps.length > 0) {
                store.dispatch('donation/currentStep', {
                    step: unCompletedSteps[0].step
                })
            }
        }
       
        
        const nextStepCallback = (fields) => {
            fields.forEach((field) => {
                if (field.dependentField) {
                    const dependentField = fields.find(
                        (item) => item.name === field.dependentField
                    );
        
                    if (dependentField) {
                        field.dependentFieldValue = dependentField.value;
                    }
                }
                fieldValidator(field);
            });
        
            const isStepValid = fields.every((field) => field.isValid);
            if (isStepValid) {
                displayInputError.value = false;
                handleStepCompleted();
                store.dispatch('donation/userInputs', { inputs: fields });
                updateItemFromStorage(
                    sessionStorageIdentifierEnum.STAFET_DONATION,
                    fields
                );
                updateBasket(userInputs.value, labels.value, store);
                scrollTo(0, 0);
            } else {
                displayInputError.value = true;
                scrollToFirstError()
            }
        };
        

        const previousStepCallback = (fields) => {
            if (currentStep.value > 1) {
                store.dispatch('donation/currentStep', {
                    step: currentStep.value - 1
                })
                
                steps.value.find(
                    (item) => item.step === currentStep.value
                ).completed = false
                
                store.dispatch('donation/steps', {
                    steps: steps.value
                })

                updateItemFromStorage(
                    sessionStorageIdentifierEnum.STAFET_DONATION,
                    fields
                )
                store.dispatch('donation/userInputs', { inputs: fields })
                scrollTo(0, 0)  
            }
        }

        const submitCallback = async () => {
            // it expects a object with ok: true or false
            const response = await store.dispatch('donation/donationSubmit')
            return response
        }

        return {
            isFormUnavailable,
            headerSteps,
            labels,
            currentStepName,
            displayInputError,
            isSubmitting,
            nextStepCallback,
            previousStepCallback,
            submitCallback,
            donationAmounts: props.donationAmounts
        }
    }
}
